import { useContext, useEffect, useState } from "react";
import { AuthContext } from "../../../Context/AuthContext";
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Typography } from "@mui/material";
import LeyendaImgView from "./LeyendaImgView";
import EscoDataGrid from "../../Controls/EscoGrid/EscoDataGrid";
import { getLeyendaImgList,frmDelLeyendasImgOc } from "../../../Service/leyendasImg";

export default function LeyendaImgDataView() {


    const [leyendasImg, setLeyendasImg] = useState([]);
    const [loading, setLoading] = useState(false);
    const { accessToken } = useContext(AuthContext);
    const { tokenExpiration, getAccessToken } = useContext(AuthContext);
    const [rowSelectd, setRowSelectd] = useState("Hola");
    

    //region - "description"

    /*DELETE INICIO*/
    const [showDelete, setShowDelete] = useState(false)

    const closeDeleteDialog = () => {
        setShowDelete(false);
    };   

    const ConfirmDelete = () => {            
        delFondoImg(rowSelectd);
        setShowDelete(false);
    }

    const delFondoImg = (row) => {

        var frmDelLeyendasImgOcRequest = {
            CodLeyendaImg: row.CodLeyendaImg
        }

        const datos = { frmDelLeyendasImgOcRequest }

        frmDelLeyendasImgOc(datos, accessToken)
            .then(data => {

                if(data!= undefined && data.Message != undefined && data.Message.includes("Error")){
                   
                    init();
                    return;
                }else{
                    init();
                }  
            }).catch(
                error => { 
                    
                }); 

    }

//endregion

    const init = () => {
        console.log('expiration', new Date(tokenExpiration), new Date(Date.now()))

        getAccessToken()
            .then((token) => {
                setLoading(true);
                getLeyendaImgList(token)
                    .then((data) => {
                        setLeyendasImg(data);
                        setLoading(false)
                    })
                    .catch()
                    .finally(() => setLoading(false))

            })
    } 

    useEffect(() => {
        init(); 
    }, [])

    const columns = [
        { field: 'DescLeyenda', headerName: 'Leyenda', width: 200 },
        { field: 'DescImagen', headerName: 'Logo', width: 200 },
        { field: 'DescPosicion', headerName: 'Posición', width: 200 },
    ];

    const rows = leyendasImg

    function getRowId(row) {
        return row.CodLeyendaImg
    }    

    function setData(data) {
        setLeyendasImg(leyendasImg.concat({ 
            CodLeyendaImg: data.CodLeyendaImg,
            CodLeyenda: data.CodLeyenda,
            DescLeyenda: data.DescLeyenda,
            stream_id: data.stream_id, 
            DescImagen: data.DescImagen, 
            DescPosicion: data.DescPosicion, 
            CodImgPosicion: data.CodImgPosicion,
            CodLeyendaImg: data.CodLeyendaImg}))
    }

        return (
            <div style={{ height: 600, width: '100%' }}>
            <Typography variant="button" sx={{ fontSize: 14, color: 'gray' }}>Configuración de Formularios: Leyendas - Logos </Typography>
            <EscoDataGrid
                rows={rows}
                columns={columns}
                loading={loading}
                getRowId={getRowId}
                pEliminar={true}
                pEditar={true}
                pSetShowDelete={setShowDelete}
                pSetRowSelectd = {setRowSelectd}   
            >
                <LeyendaImgView setData={setData} pInit={init}/>
            </EscoDataGrid>
            <Dialog open={showDelete} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
                <DialogTitle id="alert-dialog-title">
                    {"Atención"}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        ¿Desea eliminar el registro?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={closeDeleteDialog}>Cancelar</Button>
                    <Button onClick={ConfirmDelete} autoFocus>
                        Aceptar
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
        );

};